import axiosClient from './httpClient'

class InitialDataService {
  static getInitialData = () => {
    return axiosClient().get(`/initial_data`)
  }
}

export default InitialDataService
